import "core-js/modules/es6.object.define-property";

var _FORM_DATA_FIELDS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import NwApiSDK from '@nerdwallet/nw-api-sdk';
var IDENTITY_CREDIT_SCORE_RANGES = NwApiSDK.IDENTITY_SELF_REPORTED_CREDIT_SCORE_RANGES;
export var FREE_MONEY_TYPES = {
  FREE_MONEY_AUTO_INSURANCE: 'FREE_MONEY_AUTO_INSURANCE',
  FREE_MONEY_AUTO_LOANS: 'FREE_MONEY_AUTO_LOANS',
  FREE_MONEY_STUDENT_LOANS: 'FREE_MONEY_STUDENT_LOANS',
  FREE_MONEY_MORTGAGE_LOANS: 'FREE_MONEY_MORTGAGE_LOANS'
};
export var MORTGAGE_LOAN_TYPES = {
  '15_YEAR_FIXED': 'fixed_15',
  '30_YEAR_FIXED': 'fixed_30',
  '5_1_ARM': 'arm_5_1',
  OTHER: 'OTHER'
};
export var FORM_DATA_FIELDS = (_FORM_DATA_FIELDS = {}, _defineProperty(_FORM_DATA_FIELDS, FREE_MONEY_TYPES.FREE_MONEY_AUTO_INSURANCE, {
  PAYMENT_STATE: 'payment-state',
  PAYMENT_AMOUNT: 'payment-amount'
}), _defineProperty(_FORM_DATA_FIELDS, FREE_MONEY_TYPES.FREE_MONEY_STUDENT_LOANS, {
  CREDIT_SCORE: 'credit-score',
  ANNUAL_INCOME: 'annual-income'
}), _defineProperty(_FORM_DATA_FIELDS, FREE_MONEY_TYPES.FREE_MONEY_AUTO_LOANS, {
  CREDIT_SCORE: 'credit-score',
  INTEREST_RATE: 'interest-rate'
}), _defineProperty(_FORM_DATA_FIELDS, FREE_MONEY_TYPES.FREE_MONEY_MORTGAGE_LOANS, {
  MORTGAGE_TYPE: 'mortgage-type',
  INTEREST_RATE: 'interest-rate'
}), _FORM_DATA_FIELDS);
export var AUTO_LOANS_USED_CAR_INTEREST_RATES = {
  '781_850': 3.8,
  '661_780': 5.5,
  '601_660': 10,
  '501_600': 16.3,
  '300_500': 19.3
};
export var STATE_INSURANCE_RATES = {
  AL: 127,
  AK: 134,
  AZ: 102,
  AR: 117,
  CA: 164,
  CO: 130,
  CT: 137,
  DE: 132,
  FL: 153,
  GA: 183,
  HI: 117,
  ID: 88,
  IL: 114,
  IN: 100,
  IA: 88,
  KS: 113,
  KY: 125,
  LA: 164,
  ME: 80,
  MD: 151,
  MA: 134,
  MI: 213,
  MN: 113,
  MS: 115,
  MO: 101,
  MT: 168,
  NE: 110,
  NV: 116,
  NH: 82,
  NJ: 159,
  NM: 114,
  NY: 98,
  NC: 88,
  ND: 143,
  OH: 77,
  OK: 131,
  OR: 111,
  PA: 120,
  RI: 168,
  SC: 110,
  SD: 130,
  TN: 116,
  TX: 135,
  UT: 99,
  VT: 96,
  VA: 93,
  WA: 125,
  DC: 177,
  WV: 210,
  WI: 91,
  WY: 128
};
export var ELIGIBLE_STUDENT_LOAN_CREDIT_SCORE_RANGES = [IDENTITY_CREDIT_SCORE_RANGES.EXCELLENT, IDENTITY_CREDIT_SCORE_RANGES.GOOD, IDENTITY_CREDIT_SCORE_RANGES.AVERAGE];
export var MINIMIUM_STUDENT_LOAN_INCOME = 50000;